export type PhoneMediaProfile = "whatsapp-opus" | "mms-mp3" | "phone-jpeg"
export const recordedAudioTypes = ["audio/webm", "audio/ogg", "audio/mp4", "audio/x-m4a", "audio/mpeg", "audio/mp3", "audio/aac", "audio/wav", "audio/x-wav"]
export const phoneAttachmentAccept = {
  sms: ["image/jpeg", "image/png", "image/webp", ...recordedAudioTypes].join(","),
  whatsapp: ["image/jpeg", "image/png", "image/webp", "application/pdf", ...recordedAudioTypes].join(","),
}
export function phoneMediaProfile(type: string, channel: "sms" | "whatsapp"): PhoneMediaProfile | null {
  if (recordedAudioTypes.includes(type)) return channel === "whatsapp" ? "whatsapp-opus" : "mms-mp3"
  return ["image/webp", "image/png", "image/jpeg"].includes(type) ? "phone-jpeg" : null
}
export const phoneMediaOutput = {
  "whatsapp-opus": { extension: "ogg", mime: "audio/ogg", filename: "voice-message.ogg" },
  "mms-mp3": { extension: "mp3", mime: "audio/mpeg", filename: "voice-message.mp3" },
  "phone-jpeg": { extension: "jpg", mime: "image/jpeg", filename: "attachment.jpg" },
} as const
